import axiosClient from "../api/axiosClient";

/**
 * Wallet & Payouts service.
 * Ported 1:1 from the React Native app's my-wallet, gallery-payment-detail,
 * cash-out-history (+ cash-detail-sheet), and add-bank-details screens
 * (src/Screens/*) and the API functions they call in
 * src/services/api/index.js + src/services/constants/index.js.
 * No new backend endpoints — all of the below are already live.
 */

// --- Earnings ---
/** @param {{promoterId, eventId?, pageNumber, pageSize}} params */
export const getPromoterEarnings = (params) =>
  axiosClient.get("/Payments/GetPromoterGalleryEarnings", { params });

/** @param {string|number} galleryId */
export const getGalleryPayments = (galleryId) =>
  axiosClient.get("/Payments/GetPaymentsByGallery", { params: { galleryId } });

// --- Cashout ---
/** @param {{pageNumber?, pageSize?}} [params] */
export const getCashoutHistory = (params = {}) =>
  axiosClient.get("/Payments/GetMyCashoutRequests", { params });

export const getCashoutEligibility = () => axiosClient.get("/Payments/GetCashoutEligibility");

/**
 * Per-event, per-transaction breakdown of the narrow "eligible to cash out
 * right now" slice (unclaimed + past its 30-day holdback + reconciled) —
 * NOT a general revenue history (see getMyRevenueByMonth for that; this
 * one under-counts anything already paid out). Response is wrapped
 * {Success, Message, Data} rather than this app's usual {Result, Metadata}.
 */
export const getCashoutEligibilityBreakdown = () => axiosClient.get("/Payments/GetCashoutEligibilityBreakdown");

/**
 * Actual monthly earnings (every PayoutLedger row regardless of
 * cashout-eligibility status) — new backend endpoint, added specifically
 * for the Analytics revenue trend chart since nothing else reflects real
 * earnings over time.
 */
export const getMyRevenueByMonth = (monthsBack = 6) =>
  axiosClient.get("/Payments/GetMyRevenueByMonth", { params: { monthsBack } });

/** Body is intentionally empty — matches mobile's onPaymentRequestCashout({}, ...). */
export const requestCashout = () => axiosClient.post("/Payments/RequestCashout", {});

// --- Payout / bank account ---
export const getPayoutAccounts = () => axiosClient.get("/Payments/GetPayoutAccounts");

/** @param {{userId, accountHolderName, accountNumber}} payload */
export const addPayoutAccount = ({ userId, accountHolderName, accountNumber }) =>
  axiosClient.post("/Payments/AddPayoutAccount", {
    userId,
    payoutMethodId: 1, // "Bank Transfer" — the only option mobile's own UI allows
    accountHolderName,
    accountNumber,
    isDefault: true,
    isActive: true,
  });

/** @param {{payoutAccountId, accountHolderName, accountNumber}} payload */
export const updatePayoutAccount = ({ payoutAccountId, accountHolderName, accountNumber }) =>
  axiosClient.put("/Payments/UpdatePayoutAccount", {
    payoutMethodId: 1,
    PayoutAccountId: payoutAccountId,
    accountHolderName,
    accountNumber,
    IBAN: accountNumber,
    isDefault: true,
    isActive: true,
  });
